export interface ApiChatScope {
  kind: 'view' | 'view-blocks';
  view_id: string;
  block_ids?: string[];
}

/**
 * Map a Chat block's selected content-block ids + the view's available content
 * blocks to an API scope.
 *  - undefined selection => "all" => whole view.
 *  - selection covering every available block => whole view.
 *  - a non-empty subset => view-blocks with the selected ids.
 *  - no available blocks, or empty selection after dropping stale ids => null.
 */
export function toApiScope(
  selectedBlockIds: string[] | undefined,
  availableBlockIds: string[],
  viewId: string,
): ApiChatScope | null {
  if (!viewId) return null;
  if (availableBlockIds.length === 0) return null;
  const available = new Set(availableBlockIds);
  const selected =
    selectedBlockIds === undefined
      ? [...availableBlockIds]
      : selectedBlockIds.filter((id) => available.has(id));
  if (selected.length === 0) return null;
  if (selected.length === available.size) return { kind: 'view', view_id: viewId };
  return { kind: 'view-blocks', view_id: viewId, block_ids: selected };
}
